module.exports = __webpack_public_path__ + "prs2023.png?997df97e175cffb9d3282998a6b96c18";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/prs2023.png
// module id = 248
// module chunks = 0